const requestResource = (projectId, resource) => {
  return new Promise ((resolve, reject) => {
    fetch(`/api/project/${projectId}/resource`, {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(resource)
    })
    .then((responseData) => {
      resolve();
    },
    (err) => {
      console.log(err);
      // handle error in UI
      reject(err);
    });
  });
}

export { requestResource };
